/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ClarificationRequestFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type GetClarificationRequestQueryVariables = Exact<{
  resourceType: string
  id: string
}>

export type GetClarificationRequestQuery = {
  __typename: "Query"
  clarificationRequest?: {
    __typename: "ClarificationRequest"
    id: string
    content: string
    createdAt: string
    updatedAt: string
    lastUpdatedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  } | null
}

export const GetClarificationRequestDocument = gql`
  query GetClarificationRequest($resourceType: String!, $id: ID!) {
    clarificationRequest(resourceType: $resourceType, id: $id)
      @rest(
        type: "ClarificationRequest"
        endpoint: "clarificationRequest"
        path: "/project-list/{args.resourceType}/{args.id}/clarification-request"
      ) {
      ...ClarificationRequest
    }
  }
  ${ClarificationRequestFragmentDoc}
`

/**
 * __useGetClarificationRequestQuery__
 *
 * To run a query within a React component, call `useGetClarificationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClarificationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClarificationRequestQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClarificationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  > &
    (
      | { variables: GetClarificationRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  >(GetClarificationRequestDocument, options)
}
export function useGetClarificationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  >(GetClarificationRequestDocument, options)
}
// @ts-ignore
export function useGetClarificationRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetClarificationRequestQuery,
  GetClarificationRequestQueryVariables
>
export function useGetClarificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClarificationRequestQuery,
        GetClarificationRequestQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetClarificationRequestQuery | undefined,
  GetClarificationRequestQueryVariables
>
export function useGetClarificationRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClarificationRequestQuery,
        GetClarificationRequestQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetClarificationRequestQuery,
    GetClarificationRequestQueryVariables
  >(GetClarificationRequestDocument, options)
}
export type GetClarificationRequestQueryHookResult = ReturnType<
  typeof useGetClarificationRequestQuery
>
export type GetClarificationRequestLazyQueryHookResult = ReturnType<
  typeof useGetClarificationRequestLazyQuery
>
export type GetClarificationRequestSuspenseQueryHookResult = ReturnType<
  typeof useGetClarificationRequestSuspenseQuery
>
export type GetClarificationRequestQueryResult = Apollo.QueryResult<
  GetClarificationRequestQuery,
  GetClarificationRequestQueryVariables
>
